import { Link, NavLink, useNavigate } from "react-router-dom";
import { LogOut, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { AlertsBell } from "@/components/AlertsBell";

export const Logo = () => (
  <Link to="/" data-testid="header-logo-link" className="font-display text-xl font-black sm:text-2xl uppercase tracking-tight">
    Know<span className="text-[#FF2D78]">/</span>Her<span className="text-[#FF2D78]">/</span>Name
  </Link>
);

const navCls = ({ isActive }) =>
  `eyebrow transition-colors duration-200 hover:text-white ${isActive ? "!text-white" : ""}`;

export const AppHeader = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const onLogout = async () => {
    await logout();
    navigate("/");
  };
  return (
    <header className="sticky top-0 z-50 border-b border-slate-800/80 bg-[#0B0F19]/90 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-[1400px] items-center justify-between gap-4 px-4 sm:px-8">
        <Logo />
        <nav className="flex items-center gap-3 sm:gap-8">
          <NavLink to="/players" end className={(a) => `${navCls(a)} hidden sm:inline`} data-testid="nav-database-link">Database</NavLink>
          <NavLink to="/prototypes" className={navCls} data-testid="nav-prototypes-link">Prototypes</NavLink>
          <NavLink to="/leaders" className={(a) => `${navCls(a)} hidden sm:inline`} data-testid="nav-leaders-link">Leaders</NavLink>
          <NavLink to="/saved" className={(a) => `${navCls(a)} hidden sm:inline`} data-testid="nav-saved-link">Saved</NavLink>
          <AlertsBell />
          {user?.role === "admin" && (
            <NavLink to="/admin" className={navCls} data-testid="nav-admin-link">
              <span className="inline-flex items-center gap-1.5"><ShieldCheck className="h-3.5 w-3.5" />Admin</span>
            </NavLink>
          )}
          <span data-testid="header-user-name" className="hidden text-sm text-slate-400 md:inline">{user?.name}</span>
          <button
            data-testid="logout-button"
            onClick={onLogout}
            className="inline-flex items-center gap-1.5 rounded-full border border-slate-700 px-3 py-1.5 text-xs text-slate-300 transition-colors duration-200 hover:border-[#FF2D78] hover:text-white"
          >
            <LogOut className="h-3.5 w-3.5" /> <span className="hidden sm:inline">Log out</span>
          </button>
        </nav>
      </div>
    </header>
  );
};
